export default __webpack_public_path__ + "static/media/Group 555.e93a090a.png";